<template>
  <svg width="12"
       height="12"
       viewBox="0 0 12 12"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 5C6.26522 5 6.51957 5.10536 6.70711 5.29289C6.89464 5.48043 7 5.73478 7 6C7 6.26522 6.89464 6.51957 6.70711 6.70711C6.51957 6.89464 6.26522 7 6 7C5.73478 7 5.48043 6.89464 5.29289 6.70711C5.10536 6.51957 5 6.26522 5 6C5 5.73478 5.10536 5.48043 5.29289 5.29289C5.48043 5.10536 5.73478 5 6 5ZM2 2H5.5C5.76522 2 6.01957 2.10536 6.20711 2.29289C6.39464 2.48043 6.5 2.73478 6.5 3V4.5H5.5V3H2V5.5H3V4.5L4.5 6L3 7.5V6.5H2C1.73478 6.5 1.48043 6.39464 1.29289 6.20711C1.10536 6.01957 1 5.76522 1 5.5V3C1 2.73478 1.10536 2.48043 1.29289 2.29289C1.48043 2.10536 1.73478 2 2 2ZM10 10H6.5C6.23478 10 5.98043 9.89464 5.79289 9.70711C5.60536 9.51957 5.5 9.26522 5.5 9V7.5H6.5V9H10V6.5H9V7.5L7.5 6L9 4.5V5.5H10C10.2652 5.5 10.5196 5.60536 10.7071 5.79289C10.8946 5.98043 11 6.23478 11 6.5V9C11 9.26522 10.8946 9.51957 10.7071 9.70711C10.5196 9.89464 10.2652 10 10 10Z"
      :fill="color" />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "white"
    }
  }
}
</script>
